// extracted by mini-css-extract-plugin
export default {"complaint":"styles_complaint__+nsKb","disabled":"styles_disabled__21qWR"};